import React, { useState } from "react";
import { Header, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";
import { ServiceCard } from "../components/Card";
import { MessageApi } from "../app/api/message.api";
import homeData from "../app/data/homeData";


export function Contact() 
{

  const messages = MessageApi();
  
  const [inputs, setInputs] = useState();
  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);


  const handleInputs = ( event ) => {
    const { name , value } =  event.target ;
    setInputs( { ...inputs, [name] : value   } ) ;
  }

  const handleSubmit = async ( event ) => {

    event.preventDefault();
    setStatus(0);
    setIsLoading(true);
  
    try {
        const {data} = await messages.insert(inputs);
        if( data.success ){
            setStatus(1);
            setMessage( data.message );
        }
        else{
            setStatus(-1);
            setMessage('Veuillez revoir vos informations');
        }
    } catch (err) { 

        setStatus(-1);
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].message || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }       
    } finally {
        setIsLoading(false);
    }
  } 


  return(

    <div className='container-fluid' >
      {/* _____________________SECTION HEADER CONTACT ___________________ */} 

      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header page={5} /> </div>

      {/* _____________________SECTION 1 CONTACT ___________________ */} 

      <section className='row'>
        <div className='col-12 px-0'>
          <div className="bg-light-gray py-5 text-center">
            <img  src='../favicon.png'  alt='logo-ortega'  style={{ maxHeight: '80px' }} />
            <h1 className="fw-bold display-5"> Contact </h1>
            <span className='lead text-muted'> Pour vos questions ou demandes </span>
          </div>
        </div>
      </section>

      {/* _____________________SECTION 2 CONTACT ___________________ */} 

      <section className="container py-5 contact-footer">
         <div className="row g-5">
        
           {/* Colonne de Gauche : Formulaire */}
           <div className="col-md-7">
             <h2 className="fw-bold mb-4">Nous envoyer un message</h2>
             <form className="d-flex flex-column" onSubmit={ handleSubmit }>
             <div className="row">
              {
                  isLoading && (
                    <div className="d-flex justify-content-center mb-3"> 
                      <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }
                {
                  status === 1 && (
                    <div className="alert alert-success rounded-0 small mb-3 w-100"> 
                      <i className="bi bi-check-circle"></i> { message } 
                    </div>
                  )
                }
                {
                  status === -1 && (
                    <div className="alert alert-danger rounded-0 small mb-3 w-100"> 
                      <i className="bi bi-x-circle"></i> { message } 
                    </div>
                  )
                }
               </div>
               <div className="row mb-3">
                 <div className="col-md-6">
                   <label className="form-label small text-muted">Sujet</label>
                   <select name="object" className="border w-100 p-2 custom-input text-muted" onChange={ handleInputs } required >
                     <option value="" > Sélectionner l'objet du message </option>
                     <option value="service client" > Service client </option>
                     <option value="support technique" > Support technique </option>
                     <option value="partenariat" > Partenariat </option>
                     <option value="autres" > Autres </option>
                   </select>
                 </div>
                 <div className="col-md-6">
                   <label className="form-label small text-muted">Adresse mail</label>
                   <input type="email" name="email" className="border w-100 p-2 custom-input text-muted" placeholder="exemple@email.com" onChange={ handleInputs } required />
                 </div>
               </div>
            
               <div className="mb-4">
                 <label className="form-label small text-muted">Message</label>
                 <textarea name="content" className="border w-100 p-2 custom-input text-muted" rows="5" onChange={ handleInputs } required ></textarea>
               </div>

               <div className="d-flex gap-2 mb-3">
                   <input type="checkbox" name="name" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ width: '20px', height: '20px' }} />
                   <span className="small text-secondary mb-1"> J'accepte les <a href="/condition-utilisation" target="_blank" className="active-link"> conditions d'utilisation <i className="bi bi-arrow-right"></i> </a> </span>
               </div>
               <div>
                   <button type="submit" disabled={!checked} className="btn btn-green text-white rounded-0 px-4 py-2"> Envoyer <i className="bi bi-chevron-right ms-2"></i> </button>
               </div>
             </form>
           </div>

           {/* Colonne de Droite : Infos */}
           <div className="col-md-5 ps-md-5 border-start-custom">
             <h2 className="fw-bold mb-4"> Contactez-nous </h2>
          
             <div className="row mb-4">
               <div className="col-6">
                 <h6 className="fw-bold text-uppercase small-title"> Localisation </h6>
                 <p className="text-muted small mb-0"> Dakar, Sénégal </p>
                 {/* <p className="text-muted small"> Avenue </p> */}
               </div>
               <div className="col-6">
                 <h6 className="fw-bold text-uppercase small-title">Contacts</h6>
                 {/* <p className="text-muted small mb-0">Phone: +221 33 000 00 0 </p> */}
                 <p className="text-muted small mb-0">Téléphone: +221 78 826 42 42 </p>
                 <p className="text-muted small">Email: <a href="mailto:contact@ortega-hub.com" className="text-muted small" style={{ textDecoration: 'none' }}> contact@ortega-hub.com </a> </p>
               </div>
             </div>

             <div className="row">
               <div className="col-6">
                 <h6 className="fw-bold text-uppercase small-title"> NOS HORAIRES </h6>
                 <p className="text-muted small mb-0"> Lundi - Vendredi : 8h - 18h  </p>
                 <p className="text-muted small"> Samedi: 9h - 17h  </p>
               </div>
               <div className="col-6">
                 <h6 className="fw-bold text-uppercase small-title">Nous suivre</h6>
                 <div className="d-flex gap-2">
                   <a href="https://www.facebook.com/61588918603527" className="social-icon"><i className="bi bi-facebook"></i></a>
                   <a href="https://x.com/OrtegaContact" className="social-icon"><i className="bi bi-twitter"></i></a>
                   <a href="https://www.linkedin.com/company/ortega-hub" className="social-icon"><i className="bi bi-linkedin"></i></a>
                   <a href="https://www.instagram.com/ortegacontact" className="social-icon"><i className="bi bi-instagram"></i></a>
                 </div>
               </div>
             </div>
           </div>

         </div>
      </section>

      {/* _____________________SECTION 3 CONTACT ___________________ */} 

      <section className='row d-flex justify-content-center mb-0'>
        <div className='col-12 px-4 bg-light border-top py-5'>
          <div className="service-features-section">
            <div className="row bg-light p-4">
              { homeData.services.map((service, index) => (
                <ServiceCard key={index} icon={service.icon} title={service.title} description={service.description}/>
              ))}
            </div>
          </div>
       </div>
      </section>
      
      {/* _____________________SECTION FOOTER CONTACT ___________________ */} 

      <div className='row'>
        <Footer />
      </div>
      
    </div>

  )
}

